import React, { useState } from "react"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { IMediaAsset, INavigationBar } from "../../../gatsby-graphql"
import {
  LogoWrapper,
  MenuButton,
  NavBarRwdWrapper,
} from "./nav-bar-rwd-elements"
import { MenuDrawer } from "../top-bar/mobile/MenuDrawer"
import {
  MenuPosition,
  MobileMenu as GlobalMobileMenu,
} from "../top-bar/mobile/MobileMenu"
import MobileMenu from "./mobile-menu"
import { ILocaleLink } from "../top-bar/common/Locales"

interface NavBarRwdProps {
  data: INavigationBar
  locales?: ILocaleLink[]
  logo?: IMediaAsset
  locale?: string
}

const NavBarRwd = ({ data, locales, logo, locale }: NavBarRwdProps) => {
  const [isMainMenuOpen, setMainMenuOpen] = useState<boolean>(false)
  const [isGlobalMenuOpen, setGlobalMenuOpen] = useState<boolean>(false)

  return (
    <>
      <NavBarRwdWrapper>
        <MenuButton onClick={() => setMainMenuOpen(true)}>
          <GatsbyImage
            image={data.logo?.localFile?.childImageSharp?.gatsbyImageData}
            alt="logo"
          />
        </MenuButton>
        {logo && (
          <LogoWrapper>
            <Link to={`/${data.locale || "en"}/`} hrefLang={locale}>
              <GatsbyImage
                image={logo.localFile?.childImageSharp?.gatsbyImageData}
                alt="logo"
              />
            </Link>
          </LogoWrapper>
        )}
        <MenuButton onClick={() => setGlobalMenuOpen(true)}>
          <StaticImage src="../../assets/button.svg" alt="menu" />
        </MenuButton>
      </NavBarRwdWrapper>
      {isMainMenuOpen && (
        <MobileMenu data={data} closeMenu={() => setMainMenuOpen(false)} />
      )}
      {isGlobalMenuOpen && (
        <MenuDrawer
          position={MenuPosition.right}
          onClose={() => setGlobalMenuOpen(false)}
        >
          <GlobalMobileMenu games={[]} locales={locales || []} />
          {/* TODO: games */}
        </MenuDrawer>
      )}
    </>
  )
}

export default NavBarRwd
